"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PronunciationDictionariesListRequestSort = void 0;
exports.PronunciationDictionariesListRequestSort = {
    CreationTimeUnix: "creation_time_unix",
    Name: "name",
};
